import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { InvalidEmailsErrorDialogComponent } from './invalid-emails-error-dialog.component';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		GoMaterialModule
	],
	declarations: [
		InvalidEmailsErrorDialogComponent
	],
	exports: [
		InvalidEmailsErrorDialogComponent
	]
})
export class InvalidEmailsErrorDialogModule {}
